
jQuery(document).ready(function ($) {

    /*
    $(document).scroll(function () {
        if ($(document).scrollTop() > 50) {
            $("#header").addClass("active")
        } else {
            $("#header").removeClass("active")
        }
    });
    */

    // Smooth scroll sur les liens .more
    $(".bloc_hdp .more").on("click", function(e) {
        let target = $(this).attr("href")
        if (target && $(target).length) {
            e.preventDefault()
            gsap.to(window, {
                scrollTo: { y: target, autoKill: true },
                duration: 1,
                ease: "power3.inOut"
            })
        }
    })

})


